export default "__VITE_ASSET__DAWl3U7n__"